/**
 * File: SearchBar.js
 * Origin: isotect
 * Description: SearchBar component for user query inputs.
 *
 * Version: v1.0.0
 * Created: 2026-06-24
 * Last Updated: 2026-07-13
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

/**
 * SearchBar component that allows users to enter a search query.
 *
 * @component
 *
 * @param {Object} props - Component props
 * @param {string} props.query - Current search query
 * @param {(query: string) => void} props.setQuery - Callback that updates the search query
 *
 * @returns {JSX.Element} A search bar input for entering user queries
 */
function SearchBar({ query, setQuery }) {
    const handleChange = (e) => {
        setQuery(e.target.value);
    };

    return (
        <>
            <div className="searchbar">
                <input
                    className="searchbar__input"
                    type="text"
                    value={query}
                    onChange={handleChange}
                    placeholder="Search"
                />
            </div>
        </>
    );
}

export default SearchBar;
